<template>
<div class="EventInfo spackage bgc box-shadow padding-20">
    <div class="event_box">
        <img :src="eventInfoData.coveratturlid" alt="">
        <div class="event_info_box">
            <p>{{eventInfoData.title}}</p>
            <p>活动时间：{{eventInfoData.begintime}} 至 {{eventInfoData.endtime}}</p>
            <p>¥ {{eventInfoData.minprice}} - {{eventInfoData.maxprice}}</p>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'EventInfo',
    props: ['eventInfoData'],
    data() {
        return {}
    },
    mounted() {},
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.EventInfo {
    .event_box {
        background-color: #FAFAFA;
        display: flex;
        padding: 22px 20px;
        &>img {
            width: 180px;
            height: 102px;
            margin-right: 30px;
        }
        .event_info_box {
            p {
                font-size:15px;
                line-height: 21px;
            }
            p:nth-of-type(1){
                color: #303133;
                font-size:16px;
                line-height: 22px;
                font-weight: bold;
            }
            p:nth-of-type(2){
                color: #606266;
                margin: 12px 0;
            }
            p:nth-of-type(3){
                color: #FF4747;
            }
        }
    }
}
</style>